import React from 'react'
// RRD
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'
import ProtectedRoute from './components/route/ProtectedRoute'
// layout
import WithNav from './layout/WithNav'
import WithoutNav from './layout/WithoutNav'
// Pages
import Login from './pages/auth/Login'
import Orders from './pages/order/Orders'
import OrderStatus from './pages/order/OrderStatus'
import OrderDetail from './pages/order/OrderDetail'
import Setting from './pages/setting/Setting'
// utils
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import NotFound from './pages/NotFound'
import Users from './pages/user/Users'
import MyPage from './pages/profile/MyPage'

const App = () => {
  return (
    <Router>
      <div className='w-full h-full overflow-x-hidden'>
        <div className='w-full'>
          <Routes>
            <Route element={<WithoutNav />}></Route>
            <Route path='/login' element={<Login />} />
            <Route path='*' element={<NotFound />} />

            {/* Protected Route */}
            <Route element={<ProtectedRoute />}>
              <Route element={<WithNav />}>
                <Route index element={<Navigate to='/order-status' />} />
                <Route path='/orders' element={<Orders />} />
                <Route path='/order-status' element={<OrderStatus />} />
                <Route
                  path='/order/detail/:orderId'
                  element={<OrderDetail />}
                />
                <Route path='/users' element={<Users />} />
                <Route path='/setting' element={<Setting />} />
                <Route path='/profile' element={<MyPage />} />
              </Route>
            </Route>

            {/* Home ? */}
            {/* <Route element={<WithNav />}>
              <Route
                index
                element={
                  <ProtectedRoute>
                    <Navigate to='/order-status' />
                  </ProtectedRoute>
                }
              />
            </Route> */}
            {/* End Home ? */}

            {/* Order Status */}
            {/* <Route element={<WithNav />}>
              <Route
                path='/order-status'
                element={
                  <ProtectedRoute>
                    <OrderStatus />
                  </ProtectedRoute>
                }
              />
            </Route> */}
            {/* End Order Status */}

            {/* Orders */}
            {/* <Route element={<WithNav />}>
              <Route
                path='/orders'
                element={
                  <ProtectedRoute>
                    <Orders />
                  </ProtectedRoute>
                }
              />
            </Route> */}
            {/* End Orders */}

            {/* Order Detail */}
            {/* <Route element={<WithNav />}>
              <Route
                path='/order/detail/:orderId'
                element={
                  <ProtectedRoute>
                    <OrderDetail />
                  </ProtectedRoute>
                }
              />
            </Route> */}
            {/* End Order Detail */}

            {/* Setting */}
            {/* <Route element={<WithNav />}>
              <Route
                path='/setting'
                element={
                  <ProtectedRoute>
                    <Setting />
                  </ProtectedRoute>
                }
              />
            </Route> */}
            {/* End Setting */}

            {/* Setting */}
            {/* <Route element={<WithNav />}>
              <Route
                path='/users'
                element={
                  <ProtectedRoute>
                    <Users />
                  </ProtectedRoute>
                }
              />
            </Route> */}
            {/* End Setting */}

            {/* Profile / My Page */}
            {/* <Route element={<WithNav />}>
              <Route
                path='/my-page'
                element={
                  <ProtectedRoute>
                    <MyPage />
                  </ProtectedRoute>
                }
              />
            </Route> */}
            {/* End Profile / My Page */}
          </Routes>
        </div>
      </div>
      <ToastContainer />
    </Router>
  )
}

export default App
